var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _ellipse2, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 106,
    viewBox: "0 0 136 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0025 53.8724C46.7018 68.8689 18.2122 67.9734 11.7597 63.1111C5.30731 58.2488 9.2376 42.1501 20.5383 27.1536C31.839 12.1571 46.2307 3.94163 52.6832 8.80389C59.1356 13.6661 69.3032 38.8759 58.0025 53.8724Z",
    fill: "#CF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9975 53.8724C89.2982 68.8689 117.788 67.9734 124.24 63.1111C130.693 58.2488 126.762 42.1501 115.462 27.1536C104.161 12.1571 89.7693 3.94163 83.3168 8.80389C76.8644 13.6661 66.6968 38.8759 77.9975 53.8724Z",
    fill: "#CF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3921 45.7291L36.1484 44.8412L36.1064 43.6757C35.639 30.7048 39.5857 22.1592 45.2857 16.8294C51.0504 11.4393 58.9708 9 67 9C75.0291 9 82.9496 11.4393 88.7142 16.8294C94.4142 22.1592 98.3609 30.7048 97.8935 43.6757L97.8515 44.8412L98.6078 45.7291C110.529 59.7235 111.918 70.964 108.1 78.5391C104.19 86.2956 94.0891 91.7713 79.6233 92.4915L79.0667 92.5192L78.5573 92.7449C75.5171 94.0918 73.8773 94.6815 72.4894 94.8991C71.1977 95.1016 69.9375 95.0097 67.595 94.5357L67 94.4153L66.4049 94.5357C64.0624 95.0097 62.8022 95.1016 61.5105 94.8991C60.1226 94.6815 58.4829 94.0918 55.4427 92.7449L54.9332 92.5192L54.3767 92.4915C39.9109 91.7713 29.8096 86.2956 25.8998 78.5391C22.0814 70.964 23.4712 59.7235 35.3921 45.7291Z",
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59C101 70.598 94.165 77 84.5 77C74.835 77 67 67.598 67 56C67 44.402 74 36.5 79.5 36.5C88.5 36.5 89.6632 41.504 94 47C97.0119 50.817 101 54.2465 101 59Z",
    fill: "#CF7C00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.5,
    cy: 62,
    rx: 5.5,
    ry: 9,
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 56.4476C52 57.2587 50.8807 56.9371 49.5 56.9371C48.1193 56.9371 47 57.2587 47 56.4476C47 55.6365 48.1193 54 49.5 54C50.8807 54 52 55.6365 52 56.4476Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 84.5584C61.6267 87.4903 56.3636 89.2786 53 90.157C52.9995 96.5483 54.6761 96.3276 59.4072 95.705C61.376 95.4458 63.8739 95.1171 67 95.1663V95.1946C67.1626 95.1874 67.3235 95.1815 67.4828 95.1768C67.6534 95.1815 67.8258 95.1874 68 95.1946V95.1652C70.8866 95.1221 73.1964 95.4478 75.02 95.705C79.4357 96.3277 81.0004 96.5483 81 90.157C77.8745 89.2825 72.9919 87.5061 68 84.5973V84C67.8276 84.0985 67.6551 84.1959 67.4828 84.2921C67.3219 84.1959 67.1609 84.0985 67 84V84.5584Z",
    fill: "#CFCFCF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5,
    cy: 62,
    rx: 5.5,
    ry: 9,
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7371 82.6197C57.4922 80.0294 59.3321 76 62.7598 76H71.2402C74.6678 76 76.5078 80.0294 74.2629 82.6197L70.9845 86.4024C68.8821 88.8284 65.1179 88.8284 63.0155 86.4025L59.7371 82.6197Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 56.4476C87 57.2587 85.8807 56.9371 84.5 56.9371C83.1193 56.9371 82 57.2587 82 56.4476C82 55.6365 83.1193 54 84.5 54C85.8807 54 87 55.6365 87 56.4476Z",
    fill: "#F1F1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 89C63 92.5 60.5 92.5 58 93.5C58 103.5 59 105.5 67 106C75 105.5 76 103.5 76 93.5C75.3828 93.2529 74.7656 93.0669 74.125 92.874C72.1738 92.2866 70.0117 91.6353 67 89Z",
    fill: "#FF98AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.da5de1f0b8af8a8ee198cf4d2b732d22.svg";
export { ForwardRef as ReactComponent };